import * as React from "react";
import { connect } from "react-redux";

import { HeaderSubKind } from "../../Layout/SimpleTable/HeaderSubKind";
import { HorizontalAlign } from "../../Layout/SimpleTable/HorizontalAlign";
import { VerticalAlign } from "../../Layout/SimpleTable/VerticalAlign";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { EmptyCell, Root } from "./StickyTableHeaderColumn.styles";

interface StickyTableHeaderColumnProps {
    children: React.ReactNode;
    colSpan?: number;
    rowSpan?: number;
    subKind?: HeaderSubKind;
    indent?: "1" | "2" | "3" | "4" | "5" | "6";
    isGray?: boolean;
    horizontalAlign?: HorizontalAlign;
    align?: VerticalAlign;
    visible: boolean;
}

function StickyTableHeaderColumnView(props: StickyTableHeaderColumnProps): JSX.Element {
    if (!props.visible) {
        return <EmptyCell colSpan={props.colSpan} rowSpan={props.rowSpan} />;
    }
    return (
        <Root
            subKind={props.subKind}
            isGray={props.isGray}
            indent={Number(props.indent)}
            horizontalAlign={props.horizontalAlign}
            verticalAlign={props.align}
            colSpan={props.colSpan}
            rowSpan={props.rowSpan}>
            {props.children}
        </Root>
    );
}

interface StickyTableHeaderColumnContainerProps {
    condition?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: StickyTableHeaderColumnContainerProps) => ({
    visible: ownProps.condition == undefined ? true : ownProps.processEvaluableProp(state, ownProps.condition),
});

export const StickyTableHeaderColumn = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(StickyTableHeaderColumnView)))
);
